const o = {
  "roche-dropdown": "roche-dropdown",
  "roche-dropdown--no-margin": "roche-dropdown--no-margin",
  "roche-dropdown__label-wrapper": "roche-dropdown__label-wrapper",
  "roche-dropdown__label": "roche-dropdown__label",
  "roche-dropdown__select": "roche-dropdown__select",
  "roche-dropdown__select--placeholder": "roche-dropdown__select--placeholder",
  "roche-dropdown__container": "roche-dropdown__container",
  "roche-dropdown__icon": "roche-dropdown__icon",
  "roche-dropdown--secondary": "roche-dropdown--secondary",
  "roche-dropdown__select--pointer-focused": "roche-dropdown__select--pointer-focused",
  "roche-dropdown--disabled": "roche-dropdown--disabled",
  "roche-dropdown__error": "roche-dropdown__error",
  "roche-dropdown--error": "roche-dropdown--error",
  "roche-dropdown__error-text": "roche-dropdown__error-text"
};
export {
  o as default
};
